module.exports = __webpack_public_path__ + "static/media/full2.267c3392.png";